
import CitySelectModalPresenter from "./modal.js";

import CitySelectButtonView from "../view/city-select-button.js";

import CitySelectModel from "../model/city-select.js";

import Animation from "../../animation/animation.js";

import {
  yandexMaps
} from "../../../mixins/yandex-maps.js";

import {
  userCoords
} from "../../../mixins/user-coords.js";

import {
  defaultCitySelectModelData,
  USER_CITY_STORAGE_KEY,
  ActionType,
  SET_CITY_ANIMATION_DURATION
} from "../const.js";

import {
  USER_COORDS_STORAGE_KEY
} from "../../../const.js";

import {
  LocalityAbbr
} from "../lexicon.js";

import {
  CITIES_LIST
} from "../data/cities-list.js";

export default class CitySelect {
  constructor(button) {
    this._button = this._container = button;

    this._animation = new Animation();

    this._ymaps = {};

    this._modalPresenter = null;

    this._buttonView = null;
    this._model = null;

    this._handleYandexMapsLoad = this._handleYandexMapsLoad.bind(this);
    this._handleGetUserCoords = this._handleGetUserCoords.bind(this);
    this._handleCitySelectButtonClick = this._handleCitySelectButtonClick.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
    this._handleModalChangeData = this._handleModalChangeData.bind(this);
  }

  init() {
    this._buttonView = new CitySelectButtonView(this._button);
    this._model = new CitySelectModel(Object.assign(
        {},
        defaultCitySelectModelData
    ));
    this._model.addObserver(this._handleChangeData);

    if (!localStorage.getItem(USER_CITY_STORAGE_KEY)) {
      this.loadScript(this._handleYandexMapsLoad);
    } else {
      this._setCity();
    }

    this._buttonView.setClickHandler(this._handleCitySelectButtonClick);
  }

  closeModal() {
    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          isModalOpened: false
        })
    );

    this._modalPresenter.removeObserver(this._handleModalChangeData);
    this._modalPresenter = null;
  }

  _openModal() {
    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          isModalOpened: true
        }
    ), ActionType.OPEN_TRIGGER_CLICK);
  }

  _setCity(instant = true, city) {
    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          city: city || localStorage.getItem(USER_CITY_STORAGE_KEY)
        }
    ), ActionType.SET_CITY, {
      instant
    });
  }

  _processChangeCity(currentLocality) {
    localStorage.setItem(USER_CITY_STORAGE_KEY, currentLocality);

    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          city: currentLocality
        }
    ), ActionType.CHANGE_CITY);
  }

  _processOpenTriggerClick() {
    const city = (this._model.getData().city === `undefined`) ?
      defaultCitySelectModelData.city :
      this._model.getData().city;

    this._modalPresenter = new CitySelectModalPresenter(city);
    this._modalPresenter.build();
    this._modalPresenter.addObserver(this._handleModalChangeData);
  }

  _processSetCity(instant) {
    const locality = CITIES_LIST
      .find((city) => city.name === this._model.getData().city);

    const localityAbbr = (locality && locality !== `undefined`) ?
      `${LocalityAbbr[locality.type]}\u00A0` :
      ``;

    const cityText = `${localityAbbr}${this._model.getData().city}`;

    if (instant) {
      this._buttonView.setTextContent(cityText);
      return;
    }

    this._animation.fadeOut(
        this._buttonView.getElement(),
        SET_CITY_ANIMATION_DURATION,
        () => {
          if (cityText !== `undefined`) {
            this._buttonView.setTextContent(cityText);
          }

          this._animation.fadeIn(
              this._buttonView.getElement(),
              SET_CITY_ANIMATION_DURATION
          );
        }
    );
  }

  _handleCitySelectButtonClick() {
    if (this._model.getData().isModalOpened) {
      return;
    }

    this._openModal();
  }

  _handleYandexMapsLoad() {
    this._ymaps = window.ymaps;
    this._ymaps.ready(() => {
      this.getCoords(this._handleGetUserCoords);
    });
  }

  _handleGetUserCoords() {
    const coords = localStorage.getItem(USER_COORDS_STORAGE_KEY)
      .split(`,`)
      .map((item) => +item);

    this._ymaps.geocode(coords)
      .then(
          (result) => {
            const firstGeoObject = result.geoObjects.get(0);
            let city = firstGeoObject.getLocalities();

            if (!city) {
              return;
            }

            city = (Array.isArray(city)) ?
              city :
              city.split(`,`);

            city = city[0];

            localStorage.setItem(USER_CITY_STORAGE_KEY, city);
            this._setCity(false);
          },
          (error) => {
            console.error(`Ошибка определения местоположения пользователя. Текст ошибки: ${error}`);
          }
      );
  }

  _handleChangeData(action, payload) {
    switch (action) {
      case ActionType.SET_CITY:
        this._processSetCity(payload.instant);
        break;
      case ActionType.OPEN_TRIGGER_CLICK:
        this._processOpenTriggerClick();
        break;
      case ActionType.CHANGE_CITY:
        this._setCity(true, this._model.getData().city);
        break;
    }
  }

  _handleModalChangeData(action, payload) {
    switch (action) {
      case ActionType.CHANGE_CITY:
        this._processChangeCity(payload.currentLocality);
        this.closeModal();
        break;
      case ActionType.CLOSE_MODAL:
        this.closeModal();
        break;
    }
  }
}

Object.assign(CitySelect.prototype, yandexMaps);
Object.assign(CitySelect.prototype, userCoords);
